export const controllPalletTranslationEN = {
  controllPallet: {
    "controllPallet_title": "Pallet Certificate List",
    "controllPallet_newPallet": "New Pallet",
    "controllPallet_printSuccess": "Pallet printed successfully",
    "controllPallet_printError": "Error printing pallet",
    "controllPallet_deleteSuccess": "Pallet deleted successfully",
    "controllPallet_deleteError": "Pallet not deleted",
    
    // From ControlPalletsTitle.jsx
    "controllPallet_update": "Update",
    "controllPallet_delete": "Delete",
    
    // From AddPalletDetailes.jsx
    "controllPallet_newPalletTitle": "New Pallet",
    "controllPallet_palletWithId": "Pallet: {{id}}",
    "controllPallet_customerUpdated": "Customer updated successfully",
    "controllPallet_customerNotUpdated": "Customer not updated",
    "controllPallet_itemDeleted": "Item deleted successfully",
    "controllPallet_chooseCustomer": "Choose customer",
    "controllPallet_finish": "Finish",
    "controllPallet_newProduct": "New product",
    "controllPallet_updateItem": "Update item",
    "controllPallet_externalPalletNumber": "External pallet number",
    "controllPallet_dividePallet": "Divide pallet: {{palletNum}}",
    "controllPallet_dividePallet_notification_overflow": "Number of packages for division is too high"
  }
}; 